import React from 'react'

import Dico from '../../helpers/Dico';
import TextWithFieldname from '../texts/TextWithFieldname';

const Disclaimer = ({ disclaimer, developperView }) => (

    <React.Fragment>
        {disclaimer && <div className="row shadow rounded m-1">
            {disclaimer.slogan !== null && disclaimer.slogan !== undefined
                && <TextWithFieldname fieldname="slogan" variant="h4" developperView={developperView}>
                    {disclaimer.slogan && disclaimer.slogan.text &&
                        Dico.getRichText(disclaimer.slogan.text)
                    }
                </TextWithFieldname>
            }
            {disclaimer.sloganPictureUrl !== null && disclaimer.sloganPictureUrl !== undefined
                && <div className="text-center"><TextWithFieldname fieldname="sloganPictureUrl" developperView={developperView}>
                    {disclaimer.sloganPictureUrl && disclaimer.sloganPictureUrl.trim() !== '' &&
                        <img src={disclaimer.sloganPictureUrl} alt={disclaimer.sloganPictureUrl} />
                    }
                </TextWithFieldname></div>
            }
            <TextWithFieldname fieldname="representativeExample" developperView={developperView}>
                {disclaimer.representativeExample &&
                    disclaimer.representativeExample.map((line, index) => (
                        <React.Fragment key={index}>{Dico.getRichText(line.text)}</React.Fragment>
                    ))}
            </TextWithFieldname>
            {disclaimer.table !== null && disclaimer.table !== undefined
                && <TextWithFieldname fieldname="table" developperView={developperView} complexChild={true}>
                    {disclaimer.table && disclaimer.table.title && disclaimer.table.rows && disclaimer.table.header &&

                        <div className="col-12 ">
                            <div className="bg-light border-bottom border-dark p-2">
                                <h5>{disclaimer.table.title}</h5>
                            </div>

                            <div className="table-responsive">
                                <table className="table table-bordered mb-0 text-dark mb-4" style={{ fontSize: '0.75rem' }}>
                                    <thead>
                                        <tr>
                                            {disclaimer.table.header.map((row, index) => {
                                                return (
                                                    <th key={index} className='text-center fw-bold border-dark p-1'
                                                        style={{
                                                            backgroundColor: 'rgba(197, 194, 199, 0.95)',
                                                            fontSize: '0.7rem',
                                                            lineHeight: '1.2',
                                                            verticalAlign: 'middle'
                                                        }}>{row}</th>
                                                )
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {disclaimer.table.rows.map((row, indexRow) => {
                                            return <tr key={indexRow}>
                                                {row.map((obj, indexCell) => {
                                                    return <td key={indexCell} className='text-center border-dark p-1'
                                                        style={{
                                                            fontSize: '0.7rem',
                                                            lineHeight: '1.2',
                                                            verticalAlign: 'middle',
                                                            whiteSpace: 'nowrap'
                                                        }} >{obj}</td>
                                                })}
                                            </tr>
                                        })}
                                    </tbody>
                                    {disclaimer.table.footer && <tfoot>
                                        <tr><td colSpan={Object.keys(disclaimer.table.header).length}>
                                            {disclaimer.table.footer.map((footer, index) => {
                                                return <React.Fragment key={index}>{footer}<br /></React.Fragment>
                                            })}
                                        </td></tr>
                                    </tfoot>
                                    }</table>
                            </div>
                        </div>
                    }
                </TextWithFieldname>
            }
        </div>}
    </React.Fragment>
)

export default Disclaimer
